import React, { FC } from "react";
import * as Styled from "./startConversation.styles";

export const CellectAdress: FC = () => {
  return (
    <Styled.CellectInfoContainer>
      <p className="body-medium">Av. de Josep Tarradellas,</p>
      <p className="body-medium">Tel: +34 931 26 02 11</p>
      <p className="body-medium">8, 1-2, 08029 Barcelona, Spain</p>
      <p className="body-medium">Email: info@cellectenergy.com</p>
    </Styled.CellectInfoContainer>
  );
};
